import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["selectRef", "allowAllOption", "disabledLanguages", "disabledLanguageTooltipTitle", "onChange", "validLanguages", "value", "showAddMoreLanguages"];
import PropTypes from 'prop-types';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILink from 'UIComponents/link/UILink';
import UISelect from 'UIComponents/input/UISelect';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { MULTILANG_SUPPORTED_LANGUAGE_CODES } from '../constants/LanguageConstants';
import { getLanguageNameFromCode } from '../utils/langUtils';
import { getSettingUrl } from '../routing/utils/externalUrls';
import { useQuery } from 'data-fetching-client';
import { useMemo } from 'react';
import { GET_AVAILABLE_LANGUAGES } from '../knowledge-base/queries/KnowledgeBasesQuery';
import { GATES } from '../utils/gatesUtils';
import { useHasGate } from '../auth/hooks/authHooks';
import { jsx as _jsx } from "react/jsx-runtime";
const OPTION_ALL = 'all';
function LanguageItem(props) {
  const {
    children,
    disabledLanguageTooltipTitle,
    option: {
      disabled: itemDisabled
    }
  } = props;
  return /*#__PURE__*/_jsx(UITooltip, {
    placement: "left",
    title: disabledLanguageTooltipTitle,
    disabled: !itemDisabled,
    children: children
  });
}
function LanguageSelect(props) {
  const {
      selectRef,
      allowAllOption,
      disabledLanguages,
      disabledLanguageTooltipTitle,
      onChange,
      validLanguages,
      value,
      showAddMoreLanguages = false
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const {
    hasGate
  } = useHasGate(GATES.KNOWLEDGE_BASE_V3_1);
  const {
    data: languageOptionsData,
    loading: loadingLanguageOptions
  } = useQuery(GET_AVAILABLE_LANGUAGES, {
    skip: !hasGate
  });
  let options = useMemo(() => {
    const languageOptions = validLanguages || MULTILANG_SUPPORTED_LANGUAGE_CODES;
    return languageOptions.map(langCode => ({
      disabled: !!disabledLanguages.includes(langCode),
      text: getLanguageNameFromCode(langCode),
      value: langCode
    }));
  }, [disabledLanguages, validLanguages]);
  if (allowAllOption) {
    options = [
    // @ts-expect-error ts-migrate(2741) FIXME: Property 'disabled' is missing in type '{ text: st... Remove this comment to see the full error message
    {
      text: I18n.text('knowledgeContentUI.languages.all'),
      value: OPTION_ALL
    }, ...options];
  }
  const optionComponentRenderer = optionComponentProps => /*#__PURE__*/_jsx(LanguageItem, Object.assign({}, optionComponentProps, {
    disabledLanguageTooltipTitle: disabledLanguageTooltipTitle
  }));
  return /*#__PURE__*/_jsx(UISelect, Object.assign({
    ref: selectRef,
    allowCreate: false,
    dropdownFooter: showAddMoreLanguages && /*#__PURE__*/_jsx(UILink, {
      external: true,
      href: getSettingUrl('general'),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "knowledgeContentUI.manage.createLanguageVariantModal.linkToSettings"
      })
    }),
    onChange: onChange,
    isLoading: loadingLanguageOptions,
    optionComponent: optionComponentRenderer,
    options: !validLanguages && hasGate && languageOptionsData ? languageOptionsData.languages : options,
    value: value
  }, rest));
}
LanguageSelect.OPTION_ALL = OPTION_ALL;
LanguageSelect.defaultProps = {
  disabledLanguages: [],
  disabledLanguageTooltipTitle: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "knowledgeContentUI.manage.createLanguageVariantModal.languageVariationAlreadyExists"
  })
};
LanguageSelect.propTypes = {
  allowAllOption: PropTypes.bool,
  disabledLanguages: PropTypes.array,
  disabledLanguageTooltipTitle: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  onChange: PropTypes.func,
  validLanguages: PropTypes.arrayOf(PropTypes.oneOf(MULTILANG_SUPPORTED_LANGUAGE_CODES)),
  value: PropTypes.oneOf([OPTION_ALL, ...MULTILANG_SUPPORTED_LANGUAGE_CODES])
};
export default LanguageSelect;